import { render, staticRenderFns } from "./VerSignoVital.vue?vue&type=template&id=1938975d&scoped=true"
import script from "./VerSignoVital.vue?vue&type=script&lang=js"
export * from "./VerSignoVital.vue?vue&type=script&lang=js"
import style0 from "./VerSignoVital.vue?vue&type=style&index=0&id=1938975d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1938975d",
  null
  
)

export default component.exports